import { textblockTypeInputRule } from 'prosemirror-inputrules';
import { NodeExtension } from '../../../core/index.js';
import invariant from 'invariant';
import 'prosemirror-state';
import 'prosemirror-model';
import { v4 } from 'uuid';
import 'prosemirror-commands';

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var isOfType = function(type) {
    return function(value) {
        return (typeof value === "undefined" ? "undefined" : _typeof(value)) === type;
    };
};
var isNumber = isOfType("number");
var inRange = function(value, range) {
    var _Math, _Math1;
    if (!isNumber(value) || !Array.isArray(range)) {
        return false;
    }
    if (range.some(function(p) {
        return !isNumber(p);
    })) {
        return false;
    }
    return value <= (_Math = Math).max.apply(_Math, _toConsumableArray(range)) && value >= (_Math1 = Math).min.apply(_Math1, _toConsumableArray(range));
};

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var setHeading = function(level) {
    invariant(isNumber(level), "标题应为number类型");
    invariant(inRange(level, [
        1,
        6
    ]), "标题仅支持1-6级标题");
    return function(state, dispatch) {
        var tr = state.tr, selection = state.selection, schema = state.schema;
        var _schema_nodes = schema.nodes, heading = _schema_nodes.heading, paragraph = _schema_nodes.paragraph, text = _schema_nodes.text;
        var font = schema.marks.font;
        // 处于 CellSelection 时可能有多个 range
        selection.ranges.forEach(function(range) {
            var from = range.$from.pos;
            var to = range.$to.pos;
            tr.doc.nodesBetween(from, to, function(node, pos, parent) {
                // 清除已经设置的字体
                if (node.type === text && font) {
                    tr.removeMark(pos, pos + node.text.length, font);
                }
                if (node.type === paragraph || node.type === heading) {
                    // 设置标题时确保有id，避免影响目录跳转 https://ones.sankuai.com/ones/product/1859/workItem/defect/detail/65679538
                    if (node.attrs.id) {
                        tr.setNodeMarkup(pos, heading, _objectSpreadProps(_objectSpread({}, node.attrs), {
                            level: level
                        }));
                    } else {
                        tr.setNodeMarkup(pos, heading, _objectSpreadProps(_objectSpread({}, node.attrs), {
                            level: level,
                            id: v4()
                        }));
                    }
                    if ((parent.type.name === "list_item" || parent.type.name === "task_item") && tr.doc.nodeAt(pos - 1)) {
                        tr.setNodeMarkup(pos - 1, null, _objectSpreadProps(_objectSpread({}, parent.attrs), {
                            level: level
                        }));
                    }
                }
            });
        });
        dispatch(tr.scrollIntoView());
        return true;
    };
};

function _defineProperty$1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$1(target, key, source[key]);
        });
    }
    return target;
}
var getTextBlockType = function(state) {
    var selection = state.selection, tr = state.tr, schema = state.schema;
    var _schema_nodes = schema.nodes, paragraph = _schema_nodes.paragraph, heading = _schema_nodes.heading;
    var level = null;
    selection.ranges.forEach(function(range) {
        var from = range.$from.pos;
        var to = range.$to.pos;
        var keepLooking = true;
        tr.doc.nodesBetween(from, to, function(node) {
            if (!keepLooking) return false;
            if (node.type === paragraph) {
                keepLooking = false;
                level = 0;
            } else if (node.type === heading) {
                keepLooking = false;
                level = node.attrs.level;
            }
        });
    });
    return level;
};
/**
 * 获取当前光标节点选中的节点的属性（覆盖顺序为 子元素覆盖父元素）
 * @param state 模型状态
 */ var getNodeAttrs = function(state) {
    if (!state.selection.empty) return {};
    var _state_selection = state.selection, from = _state_selection.from, to = _state_selection.to;
    var result = {};
    state.tr.doc.nodesBetween(from, to, function(node) {
        result = _objectSpread$1({}, result, node.attrs);
    });
    return result;
};

var convertCommand = function(commandFunction) {
    return function(param) {
        var state = param.state, dispatch = param.dispatch, view = param.view, args = param.args;
        return commandFunction(state, dispatch, view, args);
    };
};

function styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var css_248z = ".ct-heading{font-weight:700;margin:8px 0;color:#333;word-break:break-word;clear:both}h1.ct-heading,h2.ct-heading,h3.ct-heading,h4.ct-heading{padding:8px 0}h5.ct-heading,h6.ct-heading{padding:4px 0}h1.ct-heading{font-size:28px;line-height:36px;min-height:36px}h2.ct-heading{font-size:24px;line-height:32px;min-height:32px}h3.ct-heading{font-size:20px;line-height:28px;min-height:28px}h4.ct-heading{font-size:16px;line-height:24px;min-height:24px}h5.ct-heading{font-size:14px;line-height:22px;min-height:22px}h6.ct-heading{font-size:12px;line-height:20px;min-height:20px}";
styleInject(css_248z);

function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty$2(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$2(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps$1(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof$1 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var HeadingExtension = /*#__PURE__*/ function(NodeExtension) {
    _inherits(HeadingExtension, NodeExtension);
    var _super = _createSuper(HeadingExtension);
    function HeadingExtension() {
        _classCallCheck(this, HeadingExtension);
        return _super.apply(this, arguments);
    }
    var _proto = HeadingExtension.prototype;
    _proto.commands = function commands() {
        return {
            setHeading: function(level) {
                return setHeading(level);
            },
            headingLevel: function() {
                return function(state) {
                    return getTextBlockType(state);
                };
            }
        };
    };
    _proto.inputRules = function inputRules(param) {
        var type = param.type, getState = param.getState;
        var _this_options;
        var levels = ((_this_options = this.options) === null || _this_options === void 0 ? void 0 : _this_options.level) || [
            1,
            2,
            3,
            4,
            5,
            6
        ];
        return levels.map(function(level) {
            return textblockTypeInputRule(new RegExp("^(([#＃]){1,".concat(level, "})\\s$")), type, function() {
                return _objectSpreadProps$1(_objectSpread$2({}, getNodeAttrs(getState())), {
                    level: level,
                    id: v4()
                });
            });
        });
    };
    _proto.keys = function keys() {
        var _this_options;
        var levels = ((_this_options = this.options) === null || _this_options === void 0 ? void 0 : _this_options.level) || [
            1,
            2,
            3,
            4,
            5,
            6
        ];
        var keys = {};
        levels.forEach(function(level) {
            keys["Mod-".concat(level)] = convertCommand(setHeading(level));
        });
        return keys;
    };
    _proto.transformPastedHTML = function transformPastedHTML(html) {
        if (!~html.indexOf("ct-heading")) return html;
        var createDom = document.createElement("div");
        createDom.innerHTML = html;
        var heading = createDom.querySelectorAll(".ct-heading");
        heading.forEach(function(h) {
            if (h.getAttribute("id")) h.setAttribute("id", v4());
        });
        return createDom.innerHTML;
    };
    _createClass(HeadingExtension, [
        {
            key: "name",
            get: function get() {
                return "heading";
            }
        }
    ]);
    return HeadingExtension;
}(NodeExtension);

export { HeadingExtension };
//# sourceMappingURL=index.js.map
